import { Button, Grid } from "@material-ui/core";
import React from "react";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import t from "../Locale";

const calculateLinkList = (settings) => {
  let linkList = [];

  if (settings?.enable_book_4d)
    linkList.push({
      link: "/place-bet",
      select: "4d",
      title: "4D",
    });

  if (settings?.enable_book_toto)
    linkList.push({
      link: "/toto",
      select: "toto",
      title: "TOTO",
    });

  return linkList;
};

export default function App({ select = "4d" }) {
  const hist = useHistory();
  const pathname = window.location.pathname;

  const settings = useSelector((state) => state.drawSet.set);
  const linkList = useMemo(() => calculateLinkList(settings), [settings]);

  if (linkList.length < 2) return null;

  return (
    <Grid
      container
      alignItems="center"
      style={{ marginTop: -20, marginBottom: 30 }}
    >
      {linkList.map((a, aI) => {
        return (
          <Grid item xs={12 / linkList.length} key={aI}>
            <Button
              fullWidth={true}
              variant={select === a.select ? "contained" : "outlined"}
              style={
                select === a.select
                  ? {
                      transform: "scale(110%)",
                      cursor: "not-allowed",
                    }
                  : { backgroundColor: "#fff" }
              }
              onClick={() => {
                if (pathname !== a.link) {
                  hist.push(a.link);
                }
              }}
            >
              {t(a.title)}
            </Button>
          </Grid>
        );
      })}
    </Grid>
  );
}
